export const assets = [
  {
    name: 'full',
    url: '/models/baked--05.glb'
  },
  {
    name: 'opti-100x12',
    url: '/models/221115-BRIGHT-PROTO-LANCOME-V3-BAKED-OPTI-100k-12T.glb'
  },
  {
    name: 'opti-300x12',
    url: '/models/221115-BRIGHT-PROTO-LANCOME-V3-BAKED-OPTI-300k-12T.glb'
  },
  {
    name: 'opti-100x24',
    url: '/models/221115-BRIGHT-PROTO-LANCOME-V3-BAKED-OPTI-100k-24T.glb'
  },
  {
    name: 'opti-300x24',
    url: '/models/221115-BRIGHT-PROTO-LANCOME-V3-BAKED-OPTI-300k-24T.glb'
  },
  {
    name: 'opti-100x36',
    url: '/models/221115-BRIGHT-PROTO-LANCOME-V3-BAKED-OPTI-100k-36T.glb'
  },
  {
    name: 'opti-300x36',
    url: '/models/221115-BRIGHT-PROTO-LANCOME-V3-BAKED-OPTI-300k-36T.glb'
  }
]

export const keypoints = [
  {
    'progress': 10.7,
    'title': 'Purple and scientific Microscope'
  },
  {
    'progress': 28.5,
    'title': 'Peptides metaphor around the place'
  },
  {
    'progress': 52.5,
    'title': 'Device being a point of Interest'
  },
  {
    'progress': 71.4,
    'title': 'Some other science tools'
  },
  {
    'progress': 89.5,
    'title': 'Glass based science tools'
  }
]


export const autoRenderLeveling = false

export const renderLevels = [
  ['NO_POSTPROCESS', 'NO_RETINA', 'OBJ_LOW', 'NO_SHADOW', 'RESOLUTION_LOW'],
  ['NO_POSTPROCESS', 'NO_RETINA', 'OBJ_LOW', 'NO_SHADOW'],
  ['NO_POSTPROCESS', 'NO_RETINA'],
  ['NO_POSTPROCESS'],
  []
]

export const lenses = [
  {
    url: 'lensflare0.png',
    distance: 0,
    size: 900
  },
  {
    url: 'lensflare2.png',
    distance: 0,
    size: 800
  },
  {
    url: 'lensflare3.png',
    distance: 0.1,
    size: 100
  },
  {
    url: 'lensflare3.png',
    distance: 0.2,
    size: 100
  },
]